/*
 *  Main Footer
 *
 *  Version:
 *    1.0.0 - 2019/11/10
 */

import * as ResponsiveSizes from './../../settings/Responsive';
import { register, ShopifySection } from './../../sections/ShopifySection';
import { Accordion } from './../../objects/accordion/Accordion';

export const SELECTOR_CONTAINER = '[data-footer]';
export const MENU_ACCORDION = '[data-footer-accordion]';


export class MainFooter extends ShopifySection {
  constructor(container) {
    super(container);

    this.container = container;

    this.accordion = new Accordion(this.container.find(MENU_ACCORDION));
  }

}

register(SELECTOR_CONTAINER, MainFooter);